import WithTooltip from 'app/components/WithTooltip';
import { HelpCircleIcon } from '@metarouter-private/mr-mui';
import React from 'react';

const TOOLTIP_TEXT = 'Always double check the pipeline for any staged pipeline variables';

function PipelineRevisionToolTip() {
  return (
    <WithTooltip show title={TOOLTIP_TEXT}>
      <HelpCircleIcon fontSize="small" color="secondary" />
    </WithTooltip>
  );
}

export default PipelineRevisionToolTip;
